import { createAsyncThunk } from '@reduxjs/toolkit';

import { BasicInfoHttpGetService } from 'Feature/Common/Common/Services/BasicInfoHttpService';
import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

import { IGetAllVahedHayeBimehByNoeVahedBimehPagedFilterQuery } from 'Feature/BasicInfo/Common/types/Queries/IGetAllVahedHayeBimehByNoeVahedBimehPagedFilterQuery';

export const getAllVahedHayeBimehByNoeVahedBimehPagedFilter = createAsyncThunk(
  'VahedBimeh/getAllVahedHayeBimehByNoeVahedBimehPagedFilter',
  async (query: IGetAllVahedHayeBimehByNoeVahedBimehPagedFilterQuery) => {
    return await BasicInfoHttpGetService({
      url: `${_apiPathManagerConfig?.BasicInfo.VahedBimeh.GetAllVahedHayeBimehByNoeVahedBimehPagedFilter}`,
      params: query,
    });
  }
);
